import { render, staticRenderFns } from "./Chatbots.vue?vue&type=template&id=3b41e421&scoped=true"
import script from "./Chatbots.vue?vue&type=script&lang=js"
export * from "./Chatbots.vue?vue&type=script&lang=js"
import style0 from "./Chatbots.vue?vue&type=style&index=0&id=3b41e421&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b41e421",
  null
  
)

export default component.exports